// extracted by mini-css-extract-plugin
export var actionButton = "_k8-0";
export var fileInput = "_k8-2";
export var paperclip = "_k8-1";